import axios from 'axios';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';

const shareFile = (formData) =>
    new Promise((resolve, reject) => {
        const queryBuilder = Split.getBooleanTreatment('use_express_migration_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const query = queryBuilder('/share-a-file', {});
        axios
            .post(query, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to share file'));
            });
    });

export default shareFile;
